/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    .config([
        "$httpProvider",
        function (httpProvider) {
            httpProvider
                .interceptors
                .push([
                    "$progress", "$q",
                    function (progress, q) {
                        return {
                            request: function (config) {
                                progress.start();
                                return config || q.when(config);
                            },
                            requestError: function (rejection) {
                                progress.finish();
                                return q.reject(rejection);
                            },
                            response: function (config) {
                                progress.finish();
                                return config || q.when(config);
                            },
                            responseError: function (rejection) {
                                progress.finish();
                                return q.reject(rejection);
                            }
                        };
                    }
                ]);
        }
    ])
    .factory("$progress", [
        function () {
            var progress = {
                //
                pending: 0,
                //
                total: 0,
                //
                get isPending() {
                    return this.pending > 0;
                },
                //
                get mode() {
                    return this.total !== 1 || this.pending !== 1 ? "determinate" : "indeterminate";
                },
                //
                get value() {
                    return this.total > 0 ? Math.round((this.total - this.pending) * 100 / this.total) : 100;
                },
                //
                start: function () {
                    this.pending++;
                    this.total++;
                },
                //
                finish: function () {
                    this.pending--;
                    if (this.pending === 0) {
                        this.total = 0;
                    }
                }
            };
            return progress;
        }
    ]);